export default __webpack_public_path__ + "static/media/italic_icon_grey.6c9d7e9c.svg";